import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4 mt-auto">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h5>Kod Estudio</h5>
            <p>Transformando ideas en soluciones digitales</p>
          </div>
          <div className="col-md-6 text-md-end">
            <p>© 2025 Kod Estudio. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;